import { Tab as BPTab } from '@blueprintjs/core';

export default BPTab;
